import dynamic from 'next/dynamic';
import { EventSummaryListProps } from './EventSummaryList.types';

export const EventSummaryList = dynamic<{ model: EventSummaryListProps }>(() =>
  import('./EventSummaryList').then(mod => mod.EventSummaryList)
);
